import type { InputRangeProps } from 'react-input-range'

export const ADVANCE_PAYMENT_CALCULATOR_ADVANCE_AMOUNT_RANGE: Readonly<Partial<InputRangeProps>> = {
  minValue: 1_000_000,
  maxValue: 250_000_000,
  step: 1,
}

export const ADVANCE_PAYMENT_CALCULATOR_MIN_LOAN_PERIOD_IN_DAYS = 30

export const ADVANCE_PAYMENT_CALCULATOR_MAX_ADVANCE_PAYMENT_PERIOD_IN_MONTHS = 12
